module.exports = __webpack_public_path__ + "img/kankou_17.04d106a4.jpg";